import type { PlaneSize } from '@Components/BigBrowse/Model/ModelTypes';
import { useMemo } from 'react';

import { getRoundedRectangleShape } from './RoundedRectangleGeometry';

type Props = {
  outer: PlaneSize;
  inner: PlaneSize;
  innerRadius?: number;
  outerRadius?: number;
};

export const RoundedRectangleMaskGeometry = ({
  outer,
  inner,
  innerRadius,
  outerRadius,
}: Props) => {
  const shape = useMemo(
    () => getRoundedRectangleShape(outer.width, outer.height, outerRadius),
    [outer.width, outer.height, outerRadius]
  );

  const hole = useMemo(
    () => getRoundedRectangleShape(inner.width, inner.height, innerRadius),
    [outer.width, outer.height, outerRadius]
  );

  shape.holes.push(hole);

  return <shapeBufferGeometry attach='geometry' args={[shape]} />;
};
